import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-bg">
        <div className="footer-pattern"></div>
      </div>

      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4">
            <div className="footer-brand">
              <h3 className="brand-name">ANTIPSUN</h3>
              <p className="brand-description">
                An innovative part of the blockchain trading ecosystem, designed to provide users with
                a modern platform for staking, rewards, and network growth.
              </p>
              <div className="social-links">
                <a href="#" className="social-link"><i className="bi bi-twitter"></i></a>
                <a href="#" className="social-link"><i className="bi bi-telegram"></i></a>
                <a href="#" className="social-link"><i className="bi bi-discord"></i></a>
                <a href="#" className="social-link"><i className="bi bi-github"></i></a>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-4">
            <div className="footer-widget">
              <h5 className="widget-title">Quick Links</h5>
              <ul className="widget-links">
                <li><Link to="/">Home</Link></li>
                <li><a href="#about">About</a></li>
                <li><a href="#features">Features</a></li>
                <li><a href="#roadmap">Roadmap</a></li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-4">
            <div className="footer-widget">
              <h5 className="widget-title">Platform</h5>
              <ul className="widget-links">
                <li><Link to="/dashboard">Dashboard</Link></li>
                <li><Link to="/dashboard/stake">Staking</Link></li>
                <li><Link to="/dashboard/wallet">Wallet</Link></li>
                <li><Link to="/dashboard/team">Network</Link></li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-4">
            <div className="footer-widget">
              <h5 className="widget-title">Support</h5>
              <ul className="widget-links">
                <li><a href="#faq">FAQ</a></li>
                <li><Link to="/dashboard/support">Help Center</Link></li>
                <li><a href="#">Documentation</a></li>
                <li><a href="#">Contact</a></li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2">
            <div className="footer-widget">
              <h5 className="widget-title">Legal</h5>
              <ul className="widget-links">
                <li><a href="#">Privacy Policy</a></li>
                <li><a href="#">Terms of Service</a></li>
                <li><a href="#">Cookie Policy</a></li>
                <li><a href="#">Disclaimer</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="copyright">
                © 2024 Antipsun. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="footer-badges">
                <span className="badge-item">
                  <i className="bi bi-shield-check"></i> Secure
                </span>
                <span className="badge-item">
                  <i className="bi bi-patch-check"></i> Verified
                </span>
                <span className="badge-item">
                  <i className="bi bi-lock"></i> Encrypted
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;